import axios from 'axios';

export const fetchStopPublication = (
    formId: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    axios
        .post(
            `dashboard/form/${formId}/stop-publication`,
            {},
            {
                headers: {
                    'Toast-Pending-Text': toastText?.onPendingText,
                    'Toast-Success-Text': toastText?.onSuccessText,
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
